import { Nav } from './styles/Header.style';
import { FaBars } from 'react-icons/fa';
import { Link } from 'react-router-dom';

export default function Header() {
	return (
		<Nav>
			<input type='checkbox' id='check' />
			<label htmlFor='check' className='checkbtn'>
				<FaBars />
			</label>
			<label className='logo'>
				<img src='./images/safari-logo.png' alt='' />
				{/* Safari ICT */}
			</label>
			<ul>
				<li>
					<Link to='/' alt='' className='active'>
						{' '}
						Home
					</Link>
				</li>
				<li>
					<Link to='/about' alt=''>
						{' '}
						Who We are
					</Link>
				</li>
				<li>
					<Link to='/services' alt=''>
						{' '}
						Our Services
					</Link>
				</li>
				<li>
					<Link to='/portfolio' alt=''>
						{' '}
						portfolio
					</Link>
				</li>
				<li>
					<Link to='/contact' alt=''>
						{' '}
						Contact Us
					</Link>
				</li>
			</ul>
		</Nav>
	);
}
